import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dropdown from '../utility/Dropdown';
import Button from '../utility/Button';
import ErrorDisplay from '../utility/ErrorDisplay';
import { languages as lg } from '../../constants';
import PropTypes from 'prop-types';
import LoadingSpinner from '../utility/LoadingSpinner';
import LottieLoader from '../utility/LottieLoader';
import { Helmet } from 'react-helmet';
import i18n from 'i18next';
import Cookies from 'universal-cookie';
import { withTranslation } from 'react-i18next';

import bgEverest1 from '../../images/bg_everest11.jpg';
import bgEverest2 from '../../images/bg_everest22_new.jpg';
import bgEverest3 from '../../images/bg_everest33.jpg';
import bgEverest4 from '../../images/bg_everest55.jpg';
import bgEverest5 from '../../images/bg_everest66.jpg';
import bgEverest6 from '../../images/bg_everest44.jpg';

import masthead from '../../images/everestMasthead_v2.png';
import path1 from '../../images/everestPath1.png';
import path2 from '../../images/everestPath2.png';
import path3 from '../../images/everestPath3.png';
import path4 from '../../images/everestPath4.png';
import path5 from '../../images/everestPath5.png';
import path6 from '../../images/everestPath6.png';
import path7 from '../../images/everestPath7.png';
import path8 from '../../images/everestPath8.png';

import scrollIcon from '../../images/icons/scroll_gif.gif';

import {
  fetchTrips,
  fetchAdditionalTrips,
  toggleActiveTripPopUp,
  toggleShowAllTrips,
  setSortFilter
} from '../../actions/trip';

import { resetSelectByor } from '../../actions/tripDetails';

import { setLightboxVideo, toggleLightbox } from '../../actions/lightbox';

import { clearApiError } from '../../actions/api';
import { Hidden } from 'aws-amplify-react/dist/AmplifyTheme';

const bgCard1 = {
  backgroundImage: `url("${bgEverest1}")`
};
const bgCard2 = {
  backgroundImage: `url("${bgEverest2}")`
};
const bgCard3 = {
  backgroundImage: `url("${bgEverest3}")`
};
const bgCard4 = {
  backgroundImage: `url("${bgEverest4}")`
};
const bgCard5 = {
  backgroundImage: `url("${bgEverest5}")`
};
const bgCard6 = {
  backgroundImage: `url("${bgEverest6}")`
};
const hideVisibility = {
  display: `none`
}

class Everest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentProgress: 0,
      lastScrollTop: 0
    };
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentDidUpdate() {
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    // get the scroll position in percentage
    const scrollTop = document.documentElement.scrollTop;
    const maxScrollTop = document.documentElement.scrollHeight - window.innerHeight;
    const scrollFraction = scrollTop / maxScrollTop;
    this.setState({currentProgress: (scrollFraction * 100)});
    this.setState({isEverest: false});
    // console.log((scrollFraction * 100) + '%');

    // autoscroll to bottom
    let st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
    if (st > this.state.lastScrollTop){
      if (this.state.currentProgress>85){
        // scroll to bottom
        window.scrollTo({top: document.body.scrollHeight, behavior: 'auto'});
      }
    } else {
      // scroll to top
    }
    this.setState({lastScrollTop: (st <= 0 ? 0 : st)}); // For Mobile or negative scrolling
  }

  render() {

    return (
      <>
        <div className='fe-everest-scroll-area'>

          <img src={scrollIcon} className={`fe-everest-scroll-icon ${this.state.currentProgress>20 && this.state.currentProgress<=30 ? 'to-left' : ''} ${this.state.currentProgress>6 ? 'hide' : ''}`} alt='Scroll to see more' />

          <div className={`fe-everest-card card1 showIt ${this.state.currentProgress>6 ? 'hide' : ''} ${this.state.currentProgress> 40 ? 'destroy' : ''}`} style={bgCard1}>
            <h1 style={hideVisibility}>Ford Everest Milestone</h1>
            <img src={masthead} className='fe-everest-masthead' alt='' />
            <div className='fe-everest-text text1'>
              YOUR NEXT MILESTONE IS JUST UP AHEAD
            </div>
            <div className='fe-everest-text text2'>
              Exciting experiences are coming your way
            </div>
            <img src={path1} className='fe-everest-path path1' alt='' />
          </div>

          <div className={`fe-everest-card card2 showIt ${this.state.currentProgress>25 ? 'hide' : ''}`} style={bgCard2}>
            <div className='container'>
              <div className='fe-everest-text-group1'>
                <div className='fe-everest-text text3'>
                  Life Is Yours to Master
                </div>
                <div className='fe-everest-text text4'>
                  Most people let life control them. But not you.
                  At every twist and turn, you engineer your own fate.
                  In spite of the ups and downs, you’ve made it this far.
                  Now, you’re on the verge of mastering the pinnacle of life.
                  <br/><br/>
                  But we’re curious, what’s next for you?
                </div>
              </div>

              <div className={`fe-everest-text-group2 ${this.state.currentProgress>15 ? 'showIt' : 'hide'}`}>
                <div className='fe-everest-text text5'>
                  Introducing
                </div>
                <div className='fe-everest-text text6'>
                  Ford Everest Getaways
                </div>
                <div className='fe-everest-text text7'>
                  Because you choose to rise above the ordinary, we built the Next-Gen Everest to take you
                  further. Now, we’re introducing the next chapter of your journey.
                  <br/><br/>
                  Ford Everest Getaways is your gateway to a world of sensorial experiences.
                  Discover vibrant cultures, wondrous wildlife and breathtaking landscapes in Malaysia and
                  beyond. Most importantly, master your next milestone with the people who matter most.
                </div>
              </div>
            </div>
            {/* <img src={path2} className={`fe-everest-path path2 ${this.state.currentProgress>20 ? 'hide' : 'show'}`} alt='' />
            <img src={path3} className={`fe-everest-path path3 ${this.state.currentProgress>20 ? 'show' : 'hide'}`} alt='' /> */}
            <img src={(this.state.currentProgress>15) ? path3 : path2} className={`fe-everest-path ${this.state.currentProgress>15 ? 'path3' : 'path2'}`} alt='' />
          </div>

          <div className={`fe-everest-card ${(this.state.currentProgress>40)? ((this.state.currentProgress>55)? ((this.state.currentProgress>70)?  'card6' : 'card5') : 'card4') : 'card3'} showIt`} style={(this.state.currentProgress>40)? ((this.state.currentProgress>55)? ((this.state.currentProgress>70)?  bgCard6 : bgCard5) : bgCard4) : bgCard3}>
            <div className='container'>
              {/* <div className={`fe-everest-text text8 ${this.state.currentProgress>70? 'showMobile' : ''}`}>
                STAY TUNED
                <br/>
                FOR MORE
              </div> */}
              {(this.state.currentProgress>40)? ((this.state.currentProgress>55)? ((this.state.currentProgress>70)?
                (
                  <div className='fe-everest-text text9'>
                    Introduce the little ones to
                    <br/>
                    different ways of living
                  </div>
                ) : (
                  <div className='fe-everest-text text9'>
                    Break away from the
                    <br/>
                    hustle and bustle
                    <br/>
                    of city life
                  </div>
                )) : (
                <div className='fe-everest-text text9'>
                  Reconnect with nature
                  <br/>
                  and loved ones
                </div>
              )) : (
                <div className='fe-everest-text text9'>
                  Foster curious minds and a
                  <br/>
                  love for the outdoors
                </div>
              )}

            </div>
            <img src={(this.state.currentProgress>40)? ((this.state.currentProgress>55)? ((this.state.currentProgress>70)? ((this.state.currentProgress>80)? path8 : path7) : path6) : path5) : path4} className={`fe-everest-path ${(this.state.currentProgress>40)? ((this.state.currentProgress>55)? ((this.state.currentProgress>70)? ((this.state.currentProgress>80)? 'path8' : 'path7') : 'path6') : 'path5') : 'path4'}`} alt='' />
          </div>

          {/* <div className={`fe-everest-card card3 show ${this.state.currentProgress>40 ? 'hide' : ''}`} style={bgCard3}>
            <div className='container'>
              <div className='fe-everest-text text8'>
                STAY TUNED
                <br/>
                FOR MORE
              </div>
              <div className='fe-everest-text text9'>
                Foster curious minds
                <br/>
                and a love for the outdoors
              </div>
            </div>
            <img src={path4} className='fe-everest-path path4' alt='' />
          </div>

          <div className={`fe-everest-card card4 show ${this.state.currentProgress>50 ? 'hide' : ''}`} style={bgCard4}>
            <div className='container'>
              <div className='fe-everest-text text8'>
                STAY TUNED
                <br/>
                FOR MORE
              </div>
              <div className='fe-everest-text text9'>
                Break away from the
                <br/>
                hustle and bustle
                <br/>
                of city life
              </div>
            </div>
            <img src={path5} className='fe-everest-path path4' alt='' />
          </div>

          <div className={`fe-everest-card card5 show ${this.state.currentProgress>60 ? 'hide' : ''}`} style={bgCard5}>
            <div className='container'>
              <div className='fe-everest-text text8'>
                STAY TUNED
                <br/>
                FOR MORE
              </div>
              <div className='fe-everest-text text9'>
                Reconnect with nature
                <br/>
                and loved ones
              </div>
            </div>
            <img src={path6} className='fe-everest-path path4' alt='' />
          </div>

          <div className='fe-everest-card card6 show' style={bgCard6}>
            <div className='container'>
              <div className='fe-everest-text text8'>
                STAY TUNED
                <br/>
                FOR MORE
              </div>
              <div className='fe-everest-text text9'>
                Introduce the little ones
                <br/>
                to different ways of living
              </div>
            </div>
            <img src={path7} className={`fe-everest-path path4 ${this.state.currentProgress>80 ? 'hide' : 'show'}`} alt='' />
            <img src={path8} className={`fe-everest-path path4 ${this.state.currentProgress>80 ? 'show' : 'hide'}`} alt='' />
          </div> */}

        </div>
      </>
    );
  }
}

Everest.propTypes = {
  trips: PropTypes.array.isRequired,
  totalTrips: PropTypes.number.isRequired,
  tripsLoading: PropTypes.bool.isRequired,
  tripsLoadingMore: PropTypes.bool.isRequired,
  tripsOffset: PropTypes.number.isRequired,
  tripsLimit: PropTypes.number.isRequired,
  error: PropTypes.object,
  showPopUp: PropTypes.bool.isRequired,
  fetchTrips: PropTypes.func.isRequired,
  fetchAdditionalTrips: PropTypes.func.isRequired,
  toggleActiveTripPopUp: PropTypes.func.isRequired,
  vehicleFilter: PropTypes.string.isRequired,
  sortFilter: PropTypes.object.isRequired,
  toggleShowAllTrips: PropTypes.func.isRequired,
  showAllTrips: PropTypes.bool.isRequired,
  setLightboxVideo: PropTypes.func.isRequired,
  setSortFilter: PropTypes.func.isRequired,
  toggleLightbox: PropTypes.func.isRequired,
  clearApiError: PropTypes.func.isRequired,
  videoSrc: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  hasBYOC: PropTypes.bool.isRequired,
  hasBYOR: PropTypes.bool.isRequired,
  redirect: PropTypes.bool,
  authType: PropTypes.string
};

const mapStateToProps = ({
  tripState,
  apiState,
  lightboxState,
  authState
}) => ({
  trips: tripState.trips,
  totalTrips: tripState.totalTrips,
  tripsLoading: tripState.loading,
  tripsLoadingMore: tripState.loadingMore,
  tripsOffset: tripState.offset,
  tripsLimit: tripState.limit,
  showPopUp: tripState.showPopUp,
  showAllTrips: tripState.showAllTrips,
  vehicleFilter: tripState.vehicleFilter,
  sortFilter: tripState.sortFilter,
  videoSrc: lightboxState.videoSrc,
  error: apiState.error,
  hasBYOC: tripState.hasBYOC,
  hasBYOR: tripState.hasBYOR,
  redirect: authState.redirect,
  authType: authState.authType
});

const mapDispatchToProps = {
  fetchTrips,
  fetchAdditionalTrips,
  toggleActiveTripPopUp,
  clearApiError,
  toggleShowAllTrips,
  setSortFilter,
  setLightboxVideo,
  toggleLightbox,
  resetSelectByor
};

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Everest)
);
